var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("multi-lang-maintain-core", {
    attrs: {
      title: "文章多语言维护",
      "button-text": "多语言维护",
      "dialog-width": "1320px",
      "biz-id": _vm.articleId,
      "biz-type": "ARTICLE",
      "source-lang-code": "zh-CN",
      "load-detail": _vm.loadDetail,
      "save-source": _vm.saveSource,
      maintained: _vm.maintained,
      "page-biz-ids": _vm.pageBizIds,
      "page-data-version": _vm.pageDataVersion,
    },
    on: {
      saved: function ($event) {
        return _vm.$emit("saved")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function (slotProps) {
          return [
            _c(
              "div",
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v("源数据（" + _vm._s(slotProps.defaultLangName) + "）"),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "formValidate",
                    attrs: { "label-width": "100px" },
                  },
                  [
                    _vm._l(
                      _vm.getNormalFormFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "left_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: slotProps.getSourceValue(item),
                                type: "textarea",
                                rows:
                                  item.fieldKey === "article.author" ? 1 : 2,
                                placeholder:
                                  "请输入" + slotProps.defaultLangName,
                              },
                              on: {
                                input: function ($event) {
                                  return slotProps.setSourceValue(
                                    item.fieldKey,
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.getRichFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "left_rich_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _vm.showEditor(_vm.asSourceSlot(slotProps))
                              ? _c("Tinymce", {
                                  key: _vm.getEditorKey(
                                    item.fieldKey,
                                    slotProps.sourceLangCode
                                  ),
                                  attrs: {
                                    id: _vm.getEditorId(
                                      item.fieldKey,
                                      slotProps.sourceLangCode
                                    ),
                                    value: slotProps.getSourceValue(item),
                                    height: 320,
                                    toolbar: _vm.editorToolbar,
                                    menubar: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return slotProps.setSourceValue(
                                        item.fieldKey,
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "right",
        fn: function (slotProps) {
          return [
            _c(
              "div",
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(slotProps.currentLangName) + "翻译"),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "formValidate",
                    attrs: { "label-width": "100px" },
                  },
                  [
                    _vm._l(
                      _vm.getNormalFormFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "right_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: slotProps.getCurrentValue(item.fieldKey),
                                type: "textarea",
                                rows:
                                  item.fieldKey === "article.author" ? 1 : 2,
                                placeholder:
                                  "请输入" + slotProps.currentLangName + "翻译",
                              },
                              on: {
                                input: function ($event) {
                                  return slotProps.setCurrentValue(
                                    item.fieldKey,
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.getRichFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "right_rich_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _vm.showEditor(slotProps)
                              ? _c("Tinymce", {
                                  key: _vm.getEditorKey(
                                    item.fieldKey,
                                    slotProps.activeLangCode
                                  ),
                                  attrs: {
                                    id: _vm.getEditorId(
                                      item.fieldKey,
                                      slotProps.activeLangCode
                                    ),
                                    value: slotProps.getCurrentValue(
                                      item.fieldKey
                                    ),
                                    height: 320,
                                    toolbar: _vm.editorToolbar,
                                    menubar: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return slotProps.setCurrentValue(
                                        item.fieldKey,
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }